import { Button, CircularProgress, TextField, InputAdornment } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SearchIcon from "@mui/icons-material/Search";
import { useMutation } from "react-query";
import {
  getAllConsentFormList,
  getConsentForm,
} from "../services";
import { useContext, useEffect, useRef, useState } from "react";
import usePopup from "../../../../hooks/usePopup";
import CustomFormWithPatient from "../customformPatientyData";
import { EmrContext } from "../../../index";
import { useFetchPatientDetailsByEMR } from "../../../../PatientCare/hooks/apiHooks";

function ConsentFormV2({encounterId,emrNo}:{encounterId?:number,emrNo?:string}) {
  const [selectedForm, setSelectedForm] = useState<string>("");
  const { CustomModal, showSnackbar } = usePopup();
  const [formData, setFormData] = useState<any>(null);
  const canvasRef = useRef<any>(null);
  const [showFormPreview, setShowFormPreview] = useState(false);
  const [selectedSignatureField, setSelectedSignatureField] = useState<any>(null);
  const [consentFormList, setConsentFormList] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { patientData } = useContext(EmrContext);
  const {
    mutate: fetchPatientDetails,
    data: fetchedData,
    // isLoading: isPatientLoading,
  } = useFetchPatientDetailsByEMR({});

  const isInternalContext = !!patientData?.pmaster?.id;
  const resolvedPatientData = isInternalContext ? patientData : fetchedData?.response;

  useEffect(() => {
    if (!isInternalContext && emrNo) {
      fetchPatientDetails({ emrNo, encounterId: encounterId || null });
    }
  }, [isInternalContext, emrNo, encounterId]);


  const filteredForms = consentFormList
    .filter((f) => f.formName?.toLowerCase().includes(searchTerm.toLowerCase()));

 const signatureFields =
  formData?.templateMetadata?.fields?.filter((f: any) => {
    // ✅ 1. Primary: type check
    if (f.type === "signature" || f.originalType === "signature") {
      return true;
    }

    // ✅ 2. Fallback: keyName check (controlled)
    if (f.keyName) {
      const key = f.keyName.toLowerCase();
      return (
        key.includes("signature") ||
        key.includes("sign")
      );
    }

    return false;
  }) || [];

  const activeSignatureField =
    signatureFields.find((f: any) => f.id === selectedSignatureField?.id) ||
    signatureFields[0] ||
    null;
 
  const { mutate: setCustomFormData, isLoading: customFormLoading } =
    useMutation(getConsentForm, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          setFormData(result.response);
          setShowFormPreview(true);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000
          });
        }
      },
    });

  const { mutate: getAllConsentFormListx, isLoading: _allConsentFormListLoading } =
    useMutation(getAllConsentFormList, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          console.log("allConsentFormListx====>>>>>>>>>>>>>>>>>>", result.response)
        setConsentFormList(result.response);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000
          });
        }
      },
    });
  const handleDownload = (formName: string, templateId?: number) => {
    setSelectedForm(formName);
   
  
        if (templateId) {
          setCustomFormData(templateId);
        }
        
    
  };

  useEffect(() => {
    getAllConsentFormListx()
  }, [])
  console.log("formData====>>>>>>>>>>>>>>>>>>", formData)

  return (
    <div className="w-[65vw] h-[75dvh] flex flex-col"> 
       <div className="p-4 border-b border-gray-200 bg-gray-50 flex justify-left">
        <div className="w-full max-w-sm">
          <TextField
            fullWidth
            size="small"
            placeholder="Search for a consent form..."
            value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ backgroundColor: "white", borderRadius: 1 }}
        />
        </div>
      </div>
      <CustomModal
        title="Consent form"
        open={showFormPreview}
        setOpen={setShowFormPreview}
       
      >
        <CustomFormWithPatient
          formData={formData}
          setFormData={setFormData}
          patientData={resolvedPatientData}
          signatureFields={signatureFields}
          activeSignatureField={activeSignatureField}
          setSelectedSignatureField={setSelectedSignatureField}
          canvasRef={canvasRef}
          
        />
      </CustomModal>
      <div className="flex-1 overflow-y-auto p-4 bg-gray-50/50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {filteredForms.map((item: any, index: number) => {
            const isSelected = selectedForm === item.formName;
            return (
              <Button
                key={`formButtons${index}`}
                fullWidth
                variant={isSelected ? "contained" : "outlined"}
                sx={{
                  // justifyContent: "flex-start",
                  textAlign: "center",
                  p: 1,
                  borderRadius: 2,
                  boxShadow: isSelected ? 3 : 1,
                  bgcolor: isSelected ? "primary.main" : "background.paper",
                  "&:hover": {
                    boxShadow: 3,
                    bgcolor: isSelected ? "primary.dark" : "gray.50",
                  },
                }}
                endIcon={
                  (customFormLoading ) &&
                  isSelected ? (
                    <CircularProgress size={20} />
                  ) : (
                    <PictureAsPdfIcon sx={{ ml: "auto", opacity: 0.8 }} />
                  )
                }
                disabled={
                  (customFormLoading) &&
                  isSelected
                }
                onClick={() => {
                  handleDownload(item.formName, item.templateId);
                }}
              >
                <span className="truncate font-semibold tracking-wide">
                  {item.formName}
                </span>
              </Button>
            );
          })}
        </div>

      </div>
    </div>
  );
}

export default ConsentFormV2;
